import { Radio } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

const BaseRadio_ = (props) => {
  const { field, onBlur, handleChange, children, ...rest } = props;

  return (
    <Radio
      className="base-radio--single"
      {...field}
      {...rest}
      onBlur={onBlur}
      onChange={(e) => handleChange(e.target.value)}
    >
      {children && <span className="radio-text">{children}</span>}
    </Radio>
  );
};

export const BaseRadio = BaseFormFieldWrapper(BaseRadio_);
export default BaseRadio;
